import {
  Button,
  ButtonGroup,
  Flex,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Lock from "../../images/padlock.png";
import { matchPassword } from "../../services/CustomerAPI";
import Pagination from "../Pagination";

const NoticeBoard = (props) => {
  const [id, setId] = useState("");
  const [inputPassword, setInputPassword] = useState("");

  // 유저가 입력하는 비밀번호 얻기
  const handlePasswordChange = (event) => {
    setInputPassword(event.target.value);
  };

  // 비밀글 체크
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setInputPassword("");
    setIsOpen(false);
  };

  const confirmSecretMode = (secret, id) => {
    if (secret) {
      openModal();
      setId(id);
    } else {
      window.location.href = `/customer-${props.type}/${
        props.currentPostPage + 1
      }-${id}`;
    }
  };

  const managePassword = () => {
    if (inputPassword === "") {
      alert("비밀번호를 입력해주세요!");
      return;
    }

    matchPassword(id, inputPassword).then((isPassword) => {
      if (isPassword.data) {
        window.location.href = `/customer-${props.type}/${
          props.currentPostPage + 1
        }-${id}`;
      } else {
        alert("비밀번호가 일치하지 않습니다!");
        setInputPassword("");
      }
    });
  };

  return (
    <>
      <Stack mt="30px">
        <TableContainer>
          <Table variant="simple">
            <Thead bgColor="#FFE4E4" h="35px">
              <Tr>
                <Th color="black" textAlign="center" w="10%" fontSize="2xl">
                  번호
                </Th>
                <Th color="black" textAlign="center" w="60%" fontSize="2xl">
                  제목
                </Th>
                <Th color="black" textAlign="center" w="10%" fontSize="2xl">
                  글쓴이
                </Th>
                <Th color="black" textAlign="center" w="20%" fontSize="2xl">
                  등록일
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {props.postList.map((Form, index) => {
                const startingIndex = props.currentPostPage * 10;
                const currentIndex = startingIndex + index;

                return (
                  <Tr
                    key={Form.id}
                    _hover={{
                      backgroundColor:
                        Form.admin === true ? "#FFFF32" : "#F2F2F2",
                    }}
                    backgroundColor={
                      Form.admin === true ? "#FFFFB2" : "inherit"
                    }
                  >
                    <Td textAlign="center" fontSize="xl">
                      {currentIndex + 1}
                    </Td>
                    <Td textAlign="center" fontSize="xl">
                      <Flex
                        onClick={() => {
                          confirmSecretMode(Form.secret, Form.id);
                        }}
                        cursor="pointer"
                        justifyContent="center"
                        _hover={{ color: "red" }}
                      >
                        {Form.title}
                        {Form.secret !== false && (
                          <Image src={Lock} boxSize="10px" ml="2px" mt="2px" />
                        )}
                      </Flex>
                    </Td>
                    <Td textAlign="center" fontSize="xl">
                      {Form.publisher}
                    </Td>
                    <Td textAlign="center" fontSize="xl">
                      {Form.createdAt.substr(0, 10)}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
        <Flex justifyContent="space-between" alignItems="center" mt="2%">
          <Flex justifyContent="center" flex="1">
            <Pagination
              changePage={props.changePage}
              pageCount={props.postCount}
              selectedPage={props.currentPostPage}
            />
          </Flex>
          <Flex justifyContent="flex-end">
            <Button
              onClick={() => {
                props.goPost();
              }}
              colorScheme="blue"
              variant="solid"
              px="15px"
              py="15px"
              fontSize="2xl"
            >
              글쓰기
            </Button>
          </Flex>
        </Flex>
      </Stack>

      <Modal
        blockScrollOnMount={false}
        isOpen={isOpen}
        onClose={closeModal}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          justifyContent="center"
          justifyItems="center"
          alignItems="center"
        >
          <ModalHeader textAlign="center">비밀번호 입력</ModalHeader>
          <ModalBody>
            <Input
              type="password"
              value={inputPassword}
              onChange={handlePasswordChange}
            />
          </ModalBody>
          <ModalFooter>
            <ButtonGroup spacing="2">
              <Button variant="ghost" onClick={closeModal}>
                취소
              </Button>
              <Button colorScheme="red" onClick={managePassword}>
                확인
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default NoticeBoard;
